import {
	FASTSHIFT_TICKET_STATUS,
	FastshiftTicketStatus,
} from '@wac-web/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';

import { messages } from './messages';

/**
 * Returns the lozenge appearance color for a migration ticket status.
 * Falls back to 'default' for unknown statuses.
 *
 * @param status - The migration ticket status
 * @returns The lozenge appearance color
 */
export const getTicketStatusColor = (status: FastshiftTicketStatus | null) => {
	switch (status) {
		case FASTSHIFT_TICKET_STATUS.COMPLETE:
		case FASTSHIFT_TICKET_STATUS.ON_TRACK:
			return 'success';
		case FASTSHIFT_TICKET_STATUS.AT_RISK_ATLASSIAN_OWNED:
			return 'inprogress';
		case FASTSHIFT_TICKET_STATUS.AT_RISK_PARTNER_OWNED:
			return 'new';
		case FASTSHIFT_TICKET_STATUS.NEEDS_CUSTOMER_ATTENTION:
			return 'moved';
		case FASTSHIFT_TICKET_STATUS.TO_DO:
		default:
			return 'default';
	}
};

/**
 * Returns the display message for a migration ticket status.
 * For unknown statuses, returns a fallback message instead of null to prevent UI crashes.
 *
 * @param status - The migration ticket status
 * @returns The internationalized message for the status, or a fallback for unknown statuses
 */
export const getTicketStatusText = (status: FastshiftTicketStatus | null) => {
	switch (status) {
		case FASTSHIFT_TICKET_STATUS.COMPLETE:
			return messages.ticketStatusComplete;
		case FASTSHIFT_TICKET_STATUS.ON_TRACK:
			return messages.ticketStatusOnTrack;
		case FASTSHIFT_TICKET_STATUS.AT_RISK_ATLASSIAN_OWNED:
			return messages.ticketStatusAtRiskAtlassianOwned;
		case FASTSHIFT_TICKET_STATUS.AT_RISK_PARTNER_OWNED:
			return messages.ticketStatusAtRiskPartnerOwned;
		case FASTSHIFT_TICKET_STATUS.NEEDS_CUSTOMER_ATTENTION:
			return messages.ticketStatusNeedsCustomerAttention;
		case FASTSHIFT_TICKET_STATUS.TO_DO:
			return messages.ticketStatusToDo;
		default:
			return messages.ticketStatusUnknown;
	}
};
